<template>
  <div class="animated fadeIn">
    <b-row class="ml-2">
        <b-col sm="12">
            <b-card header-tag="header">
                <div slot="header">
                    <strong>View and Upload POD</strong>
                </div>

                <b-row>
                    <b-col md="4">
                        <b-form-group
                            label="Select Dispatch Hub">
                            <v-select
                                v-model="dispatchHubId"
                                :options="hubItems.filter(item => item.value !== null)"
                                label="text"
                                :multiple="true"
                                :closeOnSelect="false"
                                placeholder="Select Dispatch Hub">
                            </v-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group
                            label="Select Vehicle Number">
                            <v-select
                                v-model="vehicleNumber"
                                :options="vehiclesNoList.filter(item => item.value !== null)"
                                label="text"
                                :multiple="true"
                                :closeOnSelect="false"
                                placeholder="Select Vehicle Number">
                            </v-select>
                        </b-form-group>

                    </b-col>

                    <b-col md="4">
                        <b-form-group
                            label="Select Transporter Name">
                            <v-select
                                v-model="transporter"
                                :options="transporterList.filter(item => item.value !== null)"
                                label="text"
                                :multiple="true"
                                :closeOnSelect="false"
                                placeholder="Select Transporter Name">
                            </v-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="3">
                        <b-form-group label="OFD Date : From">
                            <v-date-picker
                                mode="single"
                                input-class="dateInput"
                                v-model="fromDate">
                            </v-date-picker>
                        </b-form-group>
                    </b-col>

                    <b-col md="3">
                        <b-form-group label="To">
                            <v-date-picker
                                mode="single"
                                input-class="dateInput"
                                v-model="toDate">
                            </v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="7">
                        <b-form-group
                            label="Load ID/AWB Number">
                            <b-form-textarea
                                rows="2"
                                v-model="loadIdAwb"
                                placeholder="Enter Load ID/AWB Number in comma or space separated form">
                            </b-form-textarea>
                        </b-form-group>

                    </b-col>

                    <b-col
                        md="5"
                        class="d-flex align-items-center mt-4">
                        <b-button
                            variant="primary"
                            class="mr-2"
                            @click="searchData()">
                            Search
                        </b-button>
                        <b-button
                            variant="danger"
                            class="mr-2"
                            @click="clearFilters()">
                            Clear
                        </b-button>
                        <b-button
                            variant="info"
                            @click="downloadCSV"
                            >
                            Download
                        </b-button>
                    </b-col>
                </b-row>

                <!-- Records Count -->
                <b-row class="mt-2" v-if="showTable">  <!---->
                    <b-col class="text-right">
                        <strong>
                            Records:
                            <span class="text-danger">{{totalRecords}}</span>
                        </strong>
                    </b-col>
                </b-row>
                <div class="table-responsive">
                    <!--  -->
                    <b-table 
                    v-if="showTable"
                    class="no-wrap-table"
                    show-empty 
                    :busy="isBusy" 
                    :items="tableData" 
                    :fields="fields"  
                    :bordered="bordered"    
                    :filter="filter"   
                    :sort-by.sync="sortBy"  
                    :sort-desc.sync="sortDesc"   
                    :sort-direction="sortDirection"  
                    @filtered="onFiltered" 
                    :tbody-tr-class="rowClass"
                    :current-page="currentPage"
                    :per-page="perPage"
                    > 
                    
                    <template slot="createddate" slot-scope="row">
                        {{ formatDate(row.item.createddate) }}
                    </template>
                    
                    <template slot="poduploadedon" slot-scope="row">
                        {{ formatDate(row.item.poduploadedon) }}
                    </template>
                    
                    
                    <template slot="delivery_date" slot-scope="row">
                        {{ formatDate(row.item.delivery_date) }}
                    </template>

                    <template slot="action" slot-scope="row">
                        <b-button
                        size="sm"
                        variant="primary"
                        :disabled="!isPODAllowed(row.item.shipmentstatus)"
                        @click="openPodModal(row.item)">
                        View / Edit / Upload POD
                    </b-button>
                </template>
                
       
                <div slot="table-busy" class=" text-danger my-2">
                    <b-spinner class="align-middle">
                      </b-spinner>
                      <strong>Loading...</strong>
                    </div> 

                    <!-- <template slot="select" slot-scope="row">
                        <input type="checkbox" @change="multiselectdesign($event)" v-bind:value="row.item.parentawb"  class="designcheckbox"  v-model="CheckLoadID" >
                    </template> -->

                    </b-table>
                </div>
                <b-modal
                    id="podUploadModal"
                    ref="podUploadModal"
                    title="Upload POD"
                    size="lg"
                    hide-footer
                    centered
                >

                    <b-row class="align-items-center">

                        <b-col md="8">
                            <b-form-file
                                ref="podFile"
                                v-model="selectedFile"
                                browse-text="Browse"
                                accept=".jpg,.jpeg,.png"
                                placeholder="Upload POD (Image/PDF formats)">
                            </b-form-file>
                        </b-col>

                        <b-col md="4">
                            <b-button
                                variant="info"
                                class="mr-2"
                                @click="uploadPod">
                                Upload
                            </b-button>
                            <b-button
                                variant="danger"
                                @click="clearSelectedFile"
                                :disabled="!selectedFile">
                                Clear
                            </b-button>
                        </b-col>

                    </b-row>

                    <hr>

                    <b-row class="mt-4">

                        <b-col cols="7">
                            Download POD uploaded by Rider :
                        </b-col>

                        <b-col cols="5">
                            <a  v-if="podData.rider_pod_urls && podData.rider_pod_urls.length >= 1"
                                href="javascript:void(0)"
                                @click="downloadPOD('rider', podData.rider_pod_urls[podData.rider_pod_urls.length - 1], podData.poduploadedon)">
                                DOWNLOAD1
                            </a>

                            <a  v-if="podData.rider_pod_urls && podData.rider_pod_urls.length > 1"
                                href="javascript:void(0)"
                                @click="downloadPOD('rider', podData.rider_pod_urls[podData.rider_pod_urls.length - 2], podData.poduploadedon)">
                                DOWNLOAD2
                            </a>

                            <div v-if="podData.rider_pod_urls && podData.rider_pod_urls.length === 0" >
                                    image not uploaded
                            </div>

                        </b-col>

                    </b-row>

                    <b-row class="mt-3">

                        <b-col cols="7">
                            Download POD uploaded by CMS User :
                        </b-col>

                        <b-col cols="5">
                            <a v-if="podData.cms_pod_urls && podData.cms_pod_urls.length >= 1"
                                href="javascript:void(0)"
                                @click="downloadPOD('cms', podData.cms_pod_urls[podData.cms_pod_urls.length - 1], podData.poduploadedon)"
                                >
                                DOWNLOAD
                            </a>
                            <div v-if="podData.cms_pod_urls && podData.cms_pod_urls.length === 0" >
                                image not uploaded
                            </div>
                        </b-col>

                    </b-row>

                </b-modal>
                
                
                <!-- Paginationn -->
                <b-row v-if="showTable && totalRows > perPage" class="mt-3">
                    <b-col class="d-flex justify-content-center">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            first-number
                            last-number>
                        </b-pagination>

                    </b-col>

                </b-row>
            </b-card>
        </b-col>


    </b-row>
  </div>
</template>

<script>

import CONSTANTS from '@/utils/constants'
import vSelect from 'vue-select'
import 'vue-select'

export default {
    components: {
        vSelect
    },
  mounted(){
    this.hubListing();
    this.vehicleListing();
    this.transporterListing();

    // Load the default POD listing when this page is opened directly.
    if (this.$route.params.id === 'normal') {
      this.searchData();
    }
  },
  
  data() {
    const defaultToDate = new Date();
    const defaultFromDate = new Date(defaultToDate);
    defaultFromDate.setMonth(defaultFromDate.getMonth() - 1);

    return {
        podData: {},////////////////new code kuldeep /////////////////
        isBusy: false,
        selectedFile: null,
        selectedRow: null,
        showTable: false,
        hubItems: [],
        dispatchHubId: [],
        vehiclesNoList: [
            {
                value: null,
                text: "-Select vehicle Number-"
            }
        ],
        transporterList: [
            {
                value: null,
                text: "-Select Transporter-"
            },
        ],
        vehicleNumber: [],
        transporter: [],
        fromDate: defaultFromDate,
        toDate: defaultToDate,
        loadIdAwb: "",
        tableData: [],
        totalRecords: 0,
        currentPage: 1,
        perPage: 50,
        totalRows: 0,

        fields: [
            { key: "invoiceno", label: "Load ID" },
            { key: "parentawb", label: "AWB Number" },
            { key: "vehicle_no", label: "Vehicle Number" },
            { key: "vehicle_type", label: "Vehicle Type" },
            { key: "transporter_company_name", label: "Transporter Name" },
            { key: "mpscount", label: "Box Count" },
            { key: "sourcecity", label: "Origin Name" },
            { key: "destinationcity", label: "Destination Name" },
            { key: "userid", label: "User ID" },
            { key: "short_boxes", label: "Short Box Count" },
            { key: "defective_boxes", label: "Damage Box Count" },
            { key: "shipmentstatus", label: "Shipment Status" },
            { key: "hub_title", label: "Last Dispatch Hub" },////
            { key: "createddate", label: "Last OFD Date" },
            { key: "delivery_date", label: "Delivery Date" },
            { key: "lastmodifiedby", label: "Delivered By" },
            { key: "deliveredthrough", label: "Delivered Through" },
            { key: "poduploadedthrough", label: "POD Uploaded Through" },
            { key: "poduploadedby", label: "POD Uploaded By" },
            { key: "poduploadedon", label: "POD Uploaded On" },
            { key: "podstatus", label: "POD Status" },
            { key: "action", label: "View / Edit / Upload POD" }
        ],
    }
  },
    
  methods: {
    isPODAllowed(status) {
        return ["OFD", "partialDLV", "Delivered"].includes(status);
    },
/////////////////////////////////new code kuldeep///////////////////////
async openPodModal(row) {
    this.selectedRow = row;
    this.selectedFile = null;

    // Clear old POD data before API call
    this.podData = {};

    let payload = { parentawb: row.parentawb };

    try {
        const result = await this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/downloadPOD`,
            payload
        );

        console.log(result.body, "DOWNLOAD POD API RESPONSE");

        if (result.body.result == "success" || result.body.result == "POD not found") {
            this.podData = result.body;
            this.$refs.podUploadModal.show();
        } else {
            this.$fire({
                text: result.body.result || "POD not found",
                type: "warning"
            });
        }

    } catch (error) {
        console.log(error);
        this.$fire({
            text: "Unable to fetch POD details",
            type: "error"
        });
    }
},


    //////////////////////////new code end kuldeep/////////////////////////////////////
async searchData() {
    this.isBusy = true;
    // Keep the table mounted so Bootstrap Vue can display its busy loader.
    this.showTable = true;
    this.tableData = [];

    try {
        const payload = {
            hub_id: this.dispatchHubId.map(item => item.value).join(','),
            from_date: this.formatDate(this.fromDate),
            to_date: this.formatDate(this.toDate),
            vehicle_id: this.vehicleNumber.map(item => item.value).join(','),
            transporter_id: this.transporter.map(item => item.value).join(','),
            loadId_awb: this.loadIdAwb
        };
        const response = await this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPODtableListing`, payload);
        const result = response.body && response.body.returnvalue;

        if (Array.isArray(result) && result.length > 0) {
            this.tableData = result;
            this.totalRecords = this.tableData.length
            this.totalRows = this.tableData.length;
            this.currentPage = 1;
            this.showTable = true;
        } else {
            // API returned [], null, or undefined
            this.tableData = [];
            this.totalRecords = 0;
            this.totalRows = 0;
            this.currentPage = 1;
            this.showTable = true;
        }

    } catch (error) {
        console.log(error);

        // Also remove old data when API fails
        this.tableData = [];
        this.showTable = true;

        this.$fire({
            text: "Unable to fetch POD listing",
            type: "error"
        });

    } finally {
        this.isBusy = false;
    }
},

    hubListing(){
        this.isBusy=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype : `${userInfo.user_type}`,
        }
        console.log("objlist",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,obj)
        .then(result => {
            this.isBusy=false;
            if (result.body.returnmsg === "Successful") {
                this.hubItems = [
                    {
                        value: null,
                        text: "-Select Hub-"
                    }
                ];

                result.body.returnvalue.forEach(item => {
                    this.hubItems.push({
                        value: item.hubid,
                        text: item.hubname
                    });
                });

            }else{
                this.hubItems=[];
            //  this.totalRows=0;
            }
            }).catch(ex => {
            console.log("error", ex);
        });
    },


    vehicleListing(){
        this.isBusy=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype : `${userInfo.user_type}`
        }
        console.log("objlist",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getvehicles`,obj)
        .then(result => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.vehiclesNoList=[
                        {
                            value: null,
                            text: "-Select vehicle Number-"
                        }
                    ];

                    result.body.returnvalue.forEach(item => {
                        this.vehiclesNoList.push({
                            value: item.vehicle_id,
                            text: item.vehicle_no
                        });
                    });

                }else{
                    this.vehiclesNoList=[
                        {
                            value: null,
                            text: "-Select vehicle Number-"
                        }
                    ];
                    // this.totalRows=0;
                }
                }).catch(ex => {
                console.log("error", ex);
            });
    }, 

    transporterListing(){
        this.isBusy=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype : `${userInfo.user_type}`
        }
        console.log("objlist",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getTransporter`,obj)
        .then(result => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.transporterList=[
                        {
                            value: null,
                            text: "-Select Transporter Name-"
                        }
                    ];

                    result.body.returnvalue.forEach(item => {
                        this.transporterList.push({
                            value: item.transporter_id,
                            text: item.transporter_company_name
                        });
                    });
                }else{
                    this.vehiclesNoList=[
                        {
                            value: null,
                            text: "-Select vehicle Number-"
                        }
                    ];
                    // this.totalRows=0;
                }
                }).catch(ex => {
                console.log("error", ex);
            });
    },

    clearFilters() {
        this.dispatchHubId = [];
        this.vehicleNumber = [];
        this.transporter = [];
        //this.fromDate = null;
        //this.toDate = null;
        this.loadIdAwb = "";
        this.tableData = [];
        this.showTable = false;
        this.currentPage = 1;
        this.totalRows = 0;
        this.totalRecords = 0;
    },

uploadPod() {
    if (!this.selectedFile) {
        alert("Please select a file.");
        return;
    }
    
    let userdata = JSON.parse(localStorage.getItem("userData"));
    let userName = userdata.userfirstname + " " + userdata.userlastname;   
    let formData = new FormData();

    // "file" should match req.files.file in backend
    formData.append("file", this.selectedFile);
    formData.append("parentawb", this.selectedRow.parentawb);
    formData.append("imagetype", "cms");
    formData.append("userName", userName);
    this.isBusy = true;
    console.log(formData, 'formdata===============================');
    this.$http.post(
        `${CONSTANTS.MIGRATION_API_URL}/uploadPODImageToS3`,
        formData
    )
    .then(result => {

        this.isBusy = false;

        console.log(result.body);

        if (result.body.result == "success") {

            alert("File Uploaded Successfully");

            console.log("S3 URL :", result.body.image_url);

            this.$refs.podUploadModal.hide();
            this.selectedFile = null;
            // Reload table with same current filters
            this.searchData();

        } else {
            alert(result.body.result);
        }

    })
    .catch(error => {
        this.isBusy = false;
        console.log(error);
        alert("Upload Failed");
    });

},

///////////////////////////new code////////////////////////////
//     downloadRiderPod() {

//         let payload = {
//             parentawb: this.selectedRow.parentawb,
//             imagetype: "rider"
//         };

//         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadPOD`, payload)
//         .then(result => {

//             console.log(result.body, "RIDER POD DOWNLOAD " );

//             if (result.body.result == "success") {
//                 // window.open( result.body.pod_url, "_blank");
// //change code 
//                 let uploadDate = new Date(result.body.poduploadedon);

//                 let filename =
//                     "POD_" +
//                     uploadDate.getFullYear() + "-" +
//                     String(uploadDate.getMonth() + 1).padStart(2, "0") + "-" +
//                     String(uploadDate.getDate()).padStart(2, "0") + "_" +
//                     String(uploadDate.getHours()).padStart(2, "0") + "-" +
//                     String(uploadDate.getMinutes()).padStart(2, "0") + "-" +
//                     String(uploadDate.getSeconds()).padStart(2, "0") +
//                     ".jpg";

//                 fetch(result.body.pod_url)
//                     .then(response => response.blob())
//                     .then(blob => {

//                         const url = window.URL.createObjectURL(blob);

//                         const a = document.createElement("a");
//                         a.href = url;
//                         a.download = filename;

//                         document.body.appendChild(a);
//                         a.click();

//                         a.remove();
//                         window.URL.revokeObjectURL(url);
//                     });
// //change code 
//             } else {
//                 alert(result.body.result);
//             }

//         })
//         .catch(error => {
//             console.log(error);
//             alert("Download Failed");
//         });
//     },

//     downloadCmsPod() {

//         let payload = {
//             parentawb: this.selectedRow.parentawb,
//             imagetype: "cms"
//         };

//         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadPOD`, payload)
//         .then(result => {

//             console.log(result.body, "CMS POD DOWNLOAD ");

//             if (result.body.result == "success") {
//                 // window.open(result.body.pod_url, "_blank");

//                 let uploadDate = new Date(result.body.poduploadedon);

//                 let filename =
//                     "POD_" +
//                     uploadDate.getFullYear() + "-" +
//                     String(uploadDate.getMonth() + 1).padStart(2, "0") + "-" +
//                     String(uploadDate.getDate()).padStart(2, "0") + "_" +
//                     String(uploadDate.getHours()).padStart(2, "0") + "-" +
//                     String(uploadDate.getMinutes()).padStart(2, "0") + "-" +
//                     String(uploadDate.getSeconds()).padStart(2, "0") +
//                     ".jpg";

//                 fetch(result.body.pod_url)
//                     .then(response => response.blob())
//                     .then(blob => {

//                         const url = window.URL.createObjectURL(blob);

//                         const a = document.createElement("a");
//                         a.href = url;
//                         a.download = filename;

//                         document.body.appendChild(a);
//                         a.click();

//                         a.remove();
//                         window.URL.revokeObjectURL(url);
//                     });

//             } else {
//                 alert(result.body.result);
//             }
//         })
//         .catch(error => {
//             console.log(error);
//             alert("Download Failed");
//         });
//     },


downloadPOD(imagetype, podUrl, poduploadedon) {

    if (!podUrl) {
        this.$fire({
            text: `No ${imagetype} POD found`,
            type: "warning",
            timer: 5000
        });
        return;
    }

    const params = new URLSearchParams();
        params.append("pod_url", podUrl);
        params.append("imagetype", imagetype || "");
        params.append("poduploadedon", poduploadedon || "");

    const downloadUrl = `${CONSTANTS.MIGRATION_API_URL}/downloadImageOfPOD?${params.toString()}`;
    console.log("Download URL:", downloadUrl);

    window.location.href = downloadUrl;
},

/////////////////////////new code/////////////////////////////////

    formatDate(date) {
        if (!date) return null;

        const d = new Date(date);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    },

    clearSelectedFile() {
        this.selectedFile = null;

        if (this.$refs.podFile) {
            this.$refs.podFile.reset();
        }
    },// this clears the selected file


 downloadCSV() {
    if (!this.tableData || this.tableData.length === 0) {
        this.$fire({
            text: "No data available to download",
            type: "warning",
            timer: 3000
        });
        return;
    }

    // Use table fields as CSV columns
    const csvHeaders = this.fields
        .filter(field => field.key !== "action")
        .map(field => field.label);

    const csvKeys = this.fields
        .filter(field => field.key !== "action")
        .map(field => field.key);

    // Create CSV rows
    const csvRows = this.tableData.map(row => {
        return csvKeys.map(key => {
            let value = row[key];

            // Format dates
            if (
                key === "createddate" ||
                key === "delivery_date" ||
                key === "poduploadedon"
            ) {
                value = this.formatDate(value);
            }

            // Handle null / undefined
            if (value === null || value === undefined) {
                value = "";
            }

            // Convert value to string
            value = String(value);

            // Escape quotes
            value = value.replace(/"/g, '""');

            // Wrap every value in quotes
            return `"${value}"`;
        }).join(",");
    });

    // Combine header + rows
    const csvContent = [
        csvHeaders.map(header => `"${header}"`).join(","),
        ...csvRows
    ].join("\r\n");

    // Create CSV Blob
    const blob = new Blob(
        ["\ufeff" + csvContent],
        {
            type: "text/csv;charset=utf-8;"
        }
    );

    // Create download URL
    const url = window.URL.createObjectURL(blob);

    // Create temporary download link
    const link = document.createElement("a");
    link.href = url;
    link.download = "POD_Listing.csv";

    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
},

    
  }
}
</script>

<style scoped>
/*.invoicevalue{
  width: 105px !important;
}
.physicalweight{
  width: 80px;
}*/
  .table-responsive {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
}
 
.no-wrap-table table {
    white-space: nowrap;
}
 
.no-wrap-table th,
.no-wrap-table td {
    white-space: nowrap !important;
    word-break: keep-all !important;
    overflow-wrap: normal !important;
    vertical-align: middle;
}
 
.no-wrap-table .badge,
.no-wrap-table label {
    white-space: nowrap !important;
}
</style>
